import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { SERVICES, WA_PLAIN } from "@/lib/constants";

export default function Pricing() {
  return (
    <section id="harga" data-testid="pricing-section" className="py-24 lg:py-40 border-t border-ink/10">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-14 text-center"
        >
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-brand-ink mb-4">( Harga Service )</p>
          <h2 className="font-display font-extrabold uppercase tracking-tight leading-[0.95] text-4xl md:text-6xl lg:text-7xl">
            Harga <span className="text-stroke">Service</span>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base text-ink/55 leading-relaxed">
            Hubungi kami untuk mendapatkan estimasi biaya service. Biaya diinformasikan dengan jelas sebelum
            pengerjaan dimulai.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="border border-ink/10 bg-white divide-y divide-ink/10"
        >
          {SERVICES.map((s) => (
            <div
              key={s.slug}
              data-testid={`pricing-row-${s.slug}`}
              className="flex items-center justify-between gap-6 px-6 lg:px-10 py-5"
            >
              <span className="font-display font-bold text-base lg:text-lg">{s.title}</span>
              <a
                href={WA_PLAIN}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`pricing-wa-${s.slug}`}
                aria-label={`Tanya harga ${s.title} via WhatsApp`}
                className="font-mono text-xs uppercase tracking-[0.2em] text-brand-ink shrink-0 underline underline-offset-4 hover:text-ink transition-colors duration-300"
              >
                {s.price ?? "Hubungi kami"}
              </a>
            </div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-10 text-center"
        >
          <a
            href={WA_PLAIN}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="pricing-whatsapp-button"
            aria-label="Tanya harga service via WhatsApp"
            className="inline-flex items-center gap-2 rounded-full bg-brand px-8 py-4 font-display font-bold text-black hover:bg-ink hover:text-white transition-colors duration-300"
          >
            <MessageCircle size={18} strokeWidth={2.5} />
            Tanya Harga via WhatsApp
          </a>
        </motion.div>
      </div>
    </section>
  );
}
